import { Injectable } from '@angular/core';
import { UserDataService } from '@com-delta-idp/mnx-oauth';
import { LDClient, LDContext, initialize } from 'launchdarkly-js-client-sdk';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  featureFlagClient: LDClient;
  featureFlagLiveStream: Subject<any> = new Subject();

  constructor(private userData: UserDataService) {}

  enableFeatureFlagClient(sdkClientKey: string) {
    this.userData.getAuthConfigContent().subscribe((response) => {
      if (response && response['INTEGRATE_FEATURE_FLAG_CLIENT'] === true)
        this.initFeatureFlagClient(sdkClientKey);
    });
  }

  initFeatureFlagClient(sdkClientKey: string) {
    const context: LDContext = {
      kind: 'user',
      key: 'context-key'
    };
    this.featureFlagClient = initialize(sdkClientKey, context);
  }

  async getFeatureFlags(data) {
    return new Promise((resolve, reject) => {
      if (this.featureFlagClient) {
        this.featureFlagClient
          .waitForInitialization()
          .then(() => {
            this.featureFlagClient.on('change', (LDchange) => {
              this.featureFlagLiveStream.next(LDchange);
            });
            resolve(this.featureFlagClient.allFlags());
          })
          .catch((err) => {
            reject(data);
          });
      } else {
        resolve(data);
      }
    });
  }

  async shutDown() {
    if (this.featureFlagClient) {
      await this.featureFlagClient.close();
      this.featureFlagClient = null;
    }
  }
}
